import React from 'react';
import { useTranslation } from 'react-i18next';

import { DeleteDialog } from '@components/dialogs/DeleteDialog';
import { enqueueSnackbar } from 'notistack';
import { IDeleteCommentDialog } from './interface';
import { useDeleteComment, useDeleteFeedMessage } from '@reactQuery/feeds/feed';

export const DeleteCommentDialog: React.FC<IDeleteCommentDialog> = ({
  show = true,
  messageId,
  commentId,
  onClose,
  onCommentDeleted,
}): JSX.Element => {
  const { t } = useTranslation();

  const { mutate: deleteComment, isPending: isDeletingComment } =
    useDeleteComment();

  const handleDelete = () => {
    if (isDeletingComment) {
      return;
    }

    deleteComment(
      { messageId, commentId },
      {
        onSuccess: () => {
          if (onClose) {
            onClose();
          }

          if (onCommentDeleted) {
            onCommentDeleted();
          }
        },
        onError: () => {
          enqueueSnackbar(t('feed:dialogs.deleteComment.failed'), {
            variant: 'error',
          });
        },
      }
    );
  };

  return (
    <DeleteDialog
      show={show}
      title={t('feed:dialogs.deleteComment.title')}
      onClose={onClose}
      onConfirm={handleDelete}
      disabled={isDeletingComment}
    >
      {t('feed:dialogs.deleteComment.body')}
    </DeleteDialog>
  );
};
